import { render } from "./OrderItemTable.vue?vue&type=template&id=131eaafa"
import script from "./OrderItemTable.vue?vue&type=script&lang=js"
export * from "./OrderItemTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__